import { createParser } from './createParser';

type ParserFn = ReturnType<typeof createParser>;
//utility function that merges multiple parsers into one
export const composeParsers = (...parsers: ParserFn[]) => {
  const config = {};
  parsers.forEach((parser: ParserFn) => {
    if (!parser || !parser.config) return;
    Object.assign(config, parser.config);
  });
  const parser = createParser(config);

  return parser;
};
